import $ from 'jquery';

$(() => {
  'use strict';
  // ============================================================== 
  //This is for preloader
  // ============================================================== 
  window.setTimeout(() => {
    $('.preloader').fadeOut();
  }, 500); 

  // ============================================================== 
  // For page-wrapper height
  // ============================================================== 
  const set = () => {
    const topOffset = 390;
    let height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
    height = height - topOffset;
    if (height < 1) height = 1;
    if (height > topOffset) {
      $('.page-wrapper').css('min-height', (height) + 'px');
    }

  };
  $(window).ready(set);
  $(window).on('resize', set);

  // ============================================================== 
  //Tooltip
  // ============================================================== 
  $('[data-toggle=tooltip]').tooltip()

  // ============================================================== 
  //Popover
  // ============================================================== 
  $('[data-toggle=popover]').popover()

  // ============================================================== 
  // For mega menu
  // ============================================================== 
  $(document).on('click', '.mega-dropdown', (e) => {
    e.stopPropagation()
  });
  $(document).on('click', '.navbar-nav > .dropdown', function (e) {
    e.stopPropagation();
  });
  $('.dropdown-submenu').click(function () {
    $('.dropdown-submenu > .dropdown-menu').toggleClass('show');
  });
  // ============================================================== 
  // Resize all elements
  // ============================================================== 
  $('body').trigger('resize');
  // ============================================================== 
  //Fix header while scroll
  // ============================================================== 
  // const wind = $(window);
  // wind.on('load', () => {
  //   const bodyScroll = wind.scrollTop(),
  //     navbar = $('.topbar');
  //   if (bodyScroll > 100) {
  //     navbar.addClass('fixed-header animated slideInDown')
  //   } else {
  //     navbar.removeClass('fixed-header animated slideInDown')
  //   }
  // });
  $(window).scroll(() => {
    if ($(window).scrollTop() >= 200) {
      // $('.topbar').addClass('fixed-header animated slideInDown');
      $('.bt-top').addClass('visible');
    } else {
      // $('.topbar').removeClass('fixed-header animated slideInDown');
      $('.bt-top').removeClass('visible');
    }
  });

  // ============================================================== 
  // Back to top
  // ============================================================== 
  $('.bt-top').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 700);
  });

  /**
   * SMOOTH SCROLL
   * credit : https://codepen.io/kevinpowell/pen/dWzGox
   */
  $('.menu-scroll:not([target=_blank])').click(function(e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: $(this.hash).offset().top - 100
    }, 1000 );
  });
  /**
   * EXTEND ACCORDION COLLAPSE AND SHOW
   */
  $('.accordion .card').on('show.bs.collapse', function (e) {
    $(this).addClass('active');
  });
  $('.accordion .card').on('hide.bs.collapse', function (e) {
    $(this).removeClass('active');
  });
});